import _slicedToArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useCallback, useEffect } from 'react';

function hasDarkModeClass(classList) {
  if (!classList) {
    return false;
  }

  if (classList.contains('swan-promo-bar-skin-inverse') || classList.contains('swan-promo-bar-skin-holiday') || classList.contains('swan-promo-bar-skin-holiday-green')) {
    return true;
  }
}
/**
 * When the promobar variant is used with an inverse skins (or holiday skins), the buttons need to switch to white
 * This hook is responsible for adding the swan-dark-mode css class to the entire carousel when the current slide is inverse
 *
 * TODO (browser): this could be solved with the :has css selector
 *
 * min version Safari 15.4, FF (no support yet)
 *
 * ```
 * .swan-carousel-skin-promo-bar:has(.slick-current .swan-promo-bar-skin-inverse) {
 *   .slick-arrow {
 *     --swan-icon-filter-standard: var(--swan-icon-filter-white);
 *   }
 * }
 * ```
 */


function usePromoBarDarkMode(carouselRef, props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      forceDarkMode = _useState2[0],
      setForceDarkMode = _useState2[1];

  var propBeforeChange = props.beforeChange,
      children = props.children,
      skin = props.skin;
  var beforeChange = useCallback(function (current, next) {
    var _carouselRef_current, _carouselRef_current_innerSlider, _carouselRef_current_innerSlider_list;

    if (propBeforeChange) {
      propBeforeChange(current, next);
    }

    if (skin !== 'promo-bar') return; // if the next slide has dark mode set on it,

    var slideElements = (_carouselRef_current = carouselRef.current) === null || _carouselRef_current === void 0 ? void 0 : (_carouselRef_current_innerSlider = _carouselRef_current.innerSlider) === null || _carouselRef_current_innerSlider === void 0 ? void 0 : (_carouselRef_current_innerSlider_list = _carouselRef_current_innerSlider.list) === null || _carouselRef_current_innerSlider_list === void 0 ? void 0 : _carouselRef_current_innerSlider_list.querySelectorAll('.slick-slide');

    if (slideElements) {
      var nextSlide = slideElements[next];
      var promoBar = nextSlide === null || nextSlide === void 0 ? void 0 : nextSlide.querySelector('.swan-promo-bar');

      if (hasDarkModeClass(promoBar === null || promoBar === void 0 ? void 0 : promoBar.classList)) {
        setForceDarkMode(true);
      } else {
        setForceDarkMode(false);
      }
    }
  }, [carouselRef, setForceDarkMode, skin, propBeforeChange]); // we also need to run the check when the children change

  useEffect(function () {
    var _carouselRef_current, _carouselRef_current_innerSlider, _carouselRef_current_innerSlider_list;

    if (skin !== 'promo-bar') return;
    var currentSlide = (_carouselRef_current = carouselRef.current) === null || _carouselRef_current === void 0 ? void 0 : (_carouselRef_current_innerSlider = _carouselRef_current.innerSlider) === null || _carouselRef_current_innerSlider === void 0 ? void 0 : (_carouselRef_current_innerSlider_list = _carouselRef_current_innerSlider.list) === null || _carouselRef_current_innerSlider_list === void 0 ? void 0 : _carouselRef_current_innerSlider_list.querySelector('.slick-current');

    if (currentSlide) {
      var promoBar = currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.querySelector('.swan-promo-bar');

      if (hasDarkModeClass(promoBar === null || promoBar === void 0 ? void 0 : promoBar.classList)) {
        setForceDarkMode(true);
      } else {
        setForceDarkMode(false);
      }
    }
  }, [carouselRef, children, skin]);
  return {
    forceDarkMode: forceDarkMode,
    beforeChange: beforeChange
  };
}

export { usePromoBarDarkMode };